"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEditTriggerOrder = void 0;
const react_1 = require("react");
const PositionModeProvider_1 = require("../../../Assets/PositionModeProvider");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../../interface");
const CalculateUtils_1 = require("../CalculateUtils");
const FutureTriggerProcessor_1 = require("../FutureTriggerProcessor");
const operators_1 = require("rxjs/operators");
const TriggersApi_1 = require("../../../../apis/TriggersApi");
function toEditOrderReq(trigger_id, req) {
    const { accountType, symbol, trigger_price, trigger_price_type, type, amount, price, spending } = req;
    return {
        accountType,
        symbol,
        trigger_id,
        trigger_price,
        trigger_price_type,
        // TODO 这个地方应该让后端自动转为大写 @瑞松
        // 现在先前端转大写
        order_type: type.toUpperCase(),
        qty: amount,
        spending,
        price,
    };
}
/**编辑条件单hooks */
function useEditTriggerOrder(params) {
    const { order, isActive = true, leverage, symbolInfo, curPrice, marginType } = params;
    const { type, price, amount: qty, spending, side, position_side, trigger_price_type, trigger_price, trigger_id } = order;
    const { positionMode } = (0, PositionModeProvider_1.usePositionMode)(trade_utils_lib_1.AccountTradeType.trader, isActive);
    // const postOnly = type === CustomOrderType.POST;
    const reduceOnly = CalculateUtils_1.CalculateUtils.isOrderReduceOnly(side, position_side);
    // 限价单对应的价格
    const [orderPrice, setOrderPrice] = (0, react_1.useState)(price || "");
    const [investSide, setInvestSide] = (0, react_1.useState)(type === interface_1.CustomOrderType.MARKET_AMT ? interface_1.InvestSymbolSide.quote : interface_1.InvestSymbolSide.base);
    const calcValue = (0, react_1.useMemo)(() => (investSide === interface_1.InvestSymbolSide.quote ? spending : qty), [investSide, qty, spending]);
    // 订单对应的下单量
    const [orderQty, setOrderQty] = (0, react_1.useState)(calcValue);
    const [orderTriggerPrice, setOrderTriggerPrice] = (0, react_1.useState)(trigger_price);
    const [priceType, setPriceType] = (0, react_1.useState)(trigger_price_type);
    const [orderType, setOrderType] = (0, react_1.useState)(() => CalculateUtils_1.CalculateUtils.mapOrderTypeToUI(type));
    const changeOrderType = (0, react_1.useCallback)((orderType) => {
        setOrderType(orderType);
        setOrderPrice("");
    }, []);
    const checkUserModify = (0, react_1.useCallback)(() => {
        return (!new trade_utils_lib_1.SafeDecimal(orderQty).eq(new trade_utils_lib_1.SafeDecimal(calcValue)) ||
            !new trade_utils_lib_1.SafeDecimal(orderPrice).eq(new trade_utils_lib_1.SafeDecimal(price)) ||
            !new trade_utils_lib_1.SafeDecimal(orderTriggerPrice).eq(new trade_utils_lib_1.SafeDecimal(trigger_price)) ||
            priceType !== trigger_price_type ||
            CalculateUtils_1.CalculateUtils.mapOrderTypeToUI(type) !== orderType);
    }, [calcValue, orderPrice, orderQty, orderTriggerPrice, orderType, price, priceType, trigger_price, trigger_price_type, type]);
    // 只有在编辑限价单才需要进行保证金校验逻辑，市价单跟条件单都不需要进行保证金校验
    const { verifyCanTrade } = (0, FutureTriggerProcessor_1.useFuturesTriggerParams)({
        symbolInfo,
        marginType,
        orderTypeUI: orderType,
        orderSide: side,
        reduceOnly,
        postOnly: false,
        leverage: leverage !== null && leverage !== void 0 ? leverage : 5,
        investSide,
        price: orderPrice,
        qty: orderQty,
        curPrice,
        isFocused: isActive,
        triggerPrice: orderTriggerPrice,
        triggerPriceType: priceType,
        positionMode,
    });
    const modifyOrder = (0, react_1.useCallback)(() => {
        return verifyCanTrade().pipe((0, operators_1.mergeMap)((req) => {
            return (0, TriggersApi_1.modifyTriggerOrder)(toEditOrderReq(trigger_id, req.request));
        }));
    }, [trigger_id, verifyCanTrade]);
    return {
        modifyOrder,
        setOrderPrice,
        setOrderQty,
        setOrderTriggerPrice,
        orderPrice,
        orderQty,
        orderTriggerPrice,
        verifyCanTrade,
        priceType,
        setPriceType,
        orderType,
        setOrderType: changeOrderType,
        checkUserModify,
        investSide,
        setInvestSide,
    };
}
exports.useEditTriggerOrder = useEditTriggerOrder;
